import React from "react";
import PropTypes from "prop-types";
import PaginatedPageSeo from "./PaginatedPageSeo";
import EnhancePaginatedPage from "./EnhancePaginatedPage";
import PaginatedContent from "./PaginatedContent";
import WysiwygV2 from "theme/modules/WysiwygV2";
import GenderContent from "theme/components/molecules/GenderContent/GenderContent";

const PaginatedPage = (props) => {
  const EmptyPage = props.emptyPage;
  const isEmpty = props.itemsCount === 0 && !props.loading;
  let content = <EmptyPage hasFilters={props.hasFilters} />;
  let showPaginated = true;

  if (props.display_mode === "PAGE" && props.cms_block) {
    content = <WysiwygV2 content={props.cms_block.contentWysiwyg} />;
    showPaginated = false;
  } else if (
    props.display_mode === "PRODUCTS_AND_PAGE" &&
    props.cms_block &&
    !isEmpty
  ) {
    content = props.children;
  } else if (
    props.display_mode === "PRODUCTS_AND_PAGE" &&
    props.cms_block &&
    isEmpty
  ) {
    content = (
      <div>
        <WysiwygV2 content={props.cms_block.contentWysiwyg} />
        <EmptyPage hasFilters={props.hasFilters} />
      </div>
    );
  } else if (!isEmpty) {
    content = props.children;
    showPaginated = true;
  }

  return (
    <div className="paginated-page">
      <PaginatedPageSeo
        page={props.page}
        lastPage={props.lastPage}
        location={props.location}
        updatePageQuery={props.updatePageQuery}
        meta_title={props.meta_title}
        meta_description={props.meta_description}
        categoryDefaultOgDescription={props.categoryDefaultOgDescription}
        hasFilters={props.hasFilters}
      />
      {props.renderHeader && props.renderHeader()}

      {props.display_mode === "PRODUCTS_AND_PAGE" &&
      props.cms_block &&
      !isEmpty ? (
        <WysiwygV2 content={props.cms_block.contentWysiwyg} />
      ) : null}

      <PaginatedContent
        showPaginated={showPaginated}
        loading={props.loading}
        page={props.page}
        location={props.location}
        lastPage={props.lastPage}
        activeFilters={props.activeFilters}
        layer={props.layer}
        isLayerActive={props.isLayerActive}
        toggleFilters={props.toggleFilters}
        renderSorting={!isEmpty && props.renderSorting}
        renderLimit={!isEmpty && props.renderLimit}
      >
        {content}
      </PaginatedContent>

      <GenderContent
        gender_content_men_slippers={props.gender_content_men_slippers}
        gender_content_men_socks={props.gender_content_men_socks}
        gender_content_women_slippers={props.gender_content_women_slippers}
        gender_content_women_socks={props.gender_content_women_socks}
        gender_content_women_tights={props.gender_content_women_tights}
        gender_content_kids_slippers={props.gender_content_kids_slippers}
        gender_content_kids_socks={props.gender_content_kids_socks}
        gender_content_kids_tights={props.gender_content_kids_tights}
        meta_title={props.meta_title}
      />
    </div>
  );
};

PaginatedPage.propTypes = {
  ...PaginatedPageSeo.propTypes,
  ...PaginatedContent.propTypes,
  itemsCount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  renderSorting: PropTypes.func,
  renderLimit: PropTypes.func,
  renderHeader: PropTypes.func,
  hasFilters: PropTypes.bool,
  children: PropTypes.node.isRequired,
  gender_content_men_slippers: PropTypes.object,
  gender_content_men_socks: PropTypes.object,
  gender_content_women_slippers: PropTypes.object,
  gender_content_women_socks: PropTypes.object,
  gender_content_women_tights: PropTypes.object,
  gender_content_kids_slippers: PropTypes.object,
  gender_content_kids_socks: PropTypes.object,
  gender_content_kids_tights: PropTypes.object,
};

export default EnhancePaginatedPage()(PaginatedPage);
